const codePrefixClasses = "C";
const codePrefixStudents = "S";
const codePrefixGames = "G";
const codePrefixSchools = "A";
const codePrefixReferrer = "R";

export type CodePrefixClassesType = typeof codePrefixClasses;
export type CodePrefixStudentsType = typeof codePrefixStudents;
export type CodePrefixGamesType = typeof codePrefixGames;
export type CodePrefixSchoolsType = typeof codePrefixSchools;
export type CodePrefixReferrerType = typeof codePrefixReferrer;

export type CodePrefix =
    | CodePrefixClassesType
    | CodePrefixGamesType
    | CodePrefixSchoolsType
    | CodePrefixStudentsType
    | CodePrefixReferrerType;

export const CodePrefixes: { [key: string]: CodePrefix } = {
    codePrefixClasses,
    codePrefixStudents,
    codePrefixGames,
    codePrefixSchools,
    codePrefixReferrer,
};
